import React from "react";
import { Handle } from "react-flow-renderer";


const RectangleNode = ({ data }) => {
  return (
    <div style={{ background: "#ffffff", padding: "14px" }} className="border-2 border-blue-200 rounded-md">
      <Handle
        type="target"
        position="bottom"
        id={`${data.id}.bottom`}
        style={{ borderRadius: 0 }}
      />
      <div id={data.id}>{data.label}</div>
      <Handle
        type="source"
        position="top"
        id={`${data.id}.top`}
        style={{ top: "-5%", borderRadius: 0 }}
      />
   
    </div>
  );
};
const StartNode = ({ data }) => {
  return (
    <div style={{ background: "#ffffff", padding: "14px" }} className="border-2 border-blue-200 rounded-md">
    <Handle
      type="target"
      position="bottom"
      id={`${data.id}.bottom`}
      style={{ borderRadius: 0 }}
    />
    <div id={data.id} className="text-green-200">{data.label}</div>
   
 
  </div>
  );
};
const DefaultNode = ({ data }) => {
  return (
    <div style={{ background: "#ffffff", padding: "14px" }} className="border-2 border-blue-200 rounded-md">
    <Handle
      type="target"
      position="bottom"
      id={`${data.id}.bottom`}
      style={{ borderRadius: 0 }}
    />
    <div id={data.id} className="text-blue-200">{data.label}</div>
    <Handle
      type="source"
      position="top"
      id={`${data.id}.top`}
      style={{ top: "-5%", borderRadius: 0 }}
    />
 
  </div>
  );
};

const EndingNode = ({ data }) => {
  return (
    <div style={{ background: "#ffffff", padding: "14px" }} className="border-2 border-blue-200 rounded-md">
   
    <div id={data.id} className="text-red-700">{data.label}</div>
    <Handle
      type="source"
      position="top"
      id={`${data.id}.top`}
      style={{ top: "-5%", borderRadius: 0 }}
    />
 
  </div>
  );
};
export const nodeTypes = {
  rectangle: RectangleNode,
  start: StartNode,
  defa:DefaultNode,
  ending:EndingNode,

};
